import React, { useRef } from 'react';
var VeltNotificationsPanelSettingsHeaderTitle = function (props) {
    var children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-notifications-panel-settings-header-title", { ref: ref }, children));
};
export default VeltNotificationsPanelSettingsHeaderTitle;
